import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import B2BRegister from "@/pages/B2BRegister";
import Account from "@/pages/Account";
import B2BDashboard from "@/pages/B2BDashboard";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/katalog" element={<Catalog/>}/>
                <Route path="/urun/:slug" element={<ProductDetail/>}/>
                <Route path="/sepet" element={<Cart/>}/>
                <Route path="/odeme" element={<Checkout/>}/>
                <Route path="/odeme-basarili" element={<PaymentSuccess/>}/>
                <Route path="/giris" element={<Login/>}/>
                <Route path="/kayit" element={<Register/>}/>
                <Route path="/bayi-basvuru" element={<B2BRegister/>}/>
                <Route path="/hesabim" element={<Account/>}/>
                <Route path="/bayi-paneli" element={<B2BDashboard/>}/>
                <Route path="/admin" element={<Admin/>}/>
                <Route path="/hakkimizda" element={<About/>}/>
                <Route path="/iletisim" element={<Contact/>}/>
              </Routes>
            </Layout>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
